module.exports = __webpack_public_path__ + "media/images/credits_logo_large-fe5d68fec376dad7a22b7227a77f9027.png";